/* eslint-disable jsx-a11y/anchor-is-valid */
//import clsx from 'clsx'
import {FC} from 'react'
//import {toAbsoluteUrl} from '../../../../../../../../_metronic/helpers'
import {Dealer} from '../../core/_models'

type Props = {
  data: Dealer
}
const DivisionCell: FC<Props> = ({data}) => (
  <div className='d-flex align-items-center px-1'> 
    <div className='d-flex flex-column'>
        {data.division_id} -  {data.division_name}
    </div>
  </div>
)
const DealerIdCell: FC<Props> = ({data}) => (
  <div className='d-flex align-items-center px-1'> 
    <div className='d-flex flex-column'>
        {data.id}
    </div>
  </div>
)
const WarehouseNameCell: FC<Props> = ({data}) => (
  <div className='d-flex align-items-center px-1'> 
    <div className='d-flex flex-column'>
    {data.warehouse_id} - {data.warehouse_name}
    </div>
  </div>
)
const DealerNameCell: FC<Props> = ({data}) => (
  <div className='d-flex align-items-center'> 
    <div className='d-flex flex-column'>
    {data.id} - {data.dealer_name}
    </div>
  </div>
)
const AddressCell: FC<Props> = ({data}) => (
  <div className='d-flex align-items-center'> 
    <div className='d-flex flex-column'>
        {data.address}
    </div>
  </div>
)
const PhoneNumberCell: FC<Props> = ({data}) => (
  <div className='d-flex align-items-center'> 
    <div className='d-flex flex-column'>
        {data.phone_number}
    </div>
  </div>
)

const EmailCell: FC<Props> = ({data}) => (
  <div className='d-flex align-items-center'> 
    <div className='d-flex flex-column'>
        {data.email}
    </div>
  </div>
)
const TaxNumberCell: FC<Props> = ({data}) => (
  <div className='d-flex align-items-center'> 
    <div className='d-flex flex-column'>
        {data.tax_number}
    </div>
  </div>
)
const LicenseNumberCell: FC<Props> = ({data}) => (
  <div className='d-flex align-items-center'> 
    <div className='d-flex flex-column'>
        {data.license_number}
    </div>
  </div>
)
const ErpIdCell: FC<Props> = ({data}) => (
  <div className='d-flex align-items-center px-1'> 
    <div className='d-flex flex-column'>
        {data.erp_id}
    </div>
  </div>
)
const GstInNumberCell: FC<Props> = ({data}) => (
  <div className='d-flex align-items-center'> 
    <div className='d-flex flex-column'>
        {data.gst_in_number}
    </div>
  </div>
)
const ZoneCell: FC<Props> = ({data}) => (
  <div className='d-flex align-items-center px-1'> 
    <div className='d-flex flex-column'>
        {data.zone_id} - {data.zone_name}
    </div>
  </div>
)
const StateCell: FC<Props> = ({data}) => (
  <div className='d-flex align-items-center'> 
    <div className='d-flex flex-column'>
        {data.state_id} - {data.state_name}
    </div>
  </div>
)
const CityCell: FC<Props> = ({data}) => (
  <div className='d-flex align-items-center'> 
    <div className='d-flex flex-column'>
        {data.city_id} -  {data.city_name}
    </div>
  </div>
)
const DistrictCell: FC<Props> = ({data}) => (
  <div className='d-flex align-items-center'> 
    <div className='d-flex flex-column'>
        {data.district_id} - {data.district_name}
    </div>
  </div>
)

export {DivisionCell,DealerIdCell,WarehouseNameCell,ErpIdCell,DealerNameCell,AddressCell,PhoneNumberCell,EmailCell,TaxNumberCell, LicenseNumberCell, GstInNumberCell, ZoneCell, StateCell, CityCell, DistrictCell }
